import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./css/styles.css";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { setupAxiosInterceptors } from "./api/axiosSetup";
import reportWebVitals from "./reportWebVitals";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { ToastContainer } from "react-toastify";

// Install the global 401 -> silent refresh -> retry interceptor before render.
setupAxiosInterceptors();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer pauseOnHover />
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
